import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.gps-loggers-show-page', () => {
  import('./internal/show').then(({ default: Component }) => Component());
});
